import { useState } from 'react'
import { useAuth } from '../state/auth'
import { useNavigate, Link } from 'react-router-dom'
import './login.css'

export default function Login() {
    const [email, setEmail] = useState('')
    const [password, setPassword] = useState('')
    const [err, setErr] = useState(null)
    const login = useAuth(s => s.login)
    const navigate = useNavigate()
    const submit = async e => {
        e.preventDefault()
        setErr(null)
        try {
            await login(email.trim(), password)
            navigate('/projects')
        } catch (e) {
            setErr(e.message || 'Login failed')
        }
    }
    return (
        <div className="auth-wrap">
            <form className="auth-card" onSubmit={submit}>
                <h1>Sign in</h1>
                {err && <div className="error">{err}</div>}
                <label>Email</label>
                <input value={email} onChange={e=>setEmail(e.target.value)} type="email" autoFocus />
                <label>Password</label>
                <input value={password} onChange={e=>setPassword(e.target.value)} type="password" />
                <button type="submit">Continue</button>
                <div style={{marginTop:12,fontSize:13,opacity:.8}}>
                    New here? <Link to="/register">Create an account</Link>
                </div>
            </form>
        </div>
    )
}
